export default __webpack_public_path__ + "static/media/Demetrius.Williamson (n.2022).ae0d1023.pdf";